import { render, staticRenderFns } from "./StylingModelCategories.vue?vue&type=template&id=4309a9ac"
import script from "./StylingModelCategories.vue?vue&type=script&lang=js"
export * from "./StylingModelCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports